import React from 'react';

const StyledText = ({ text }) => {
    const classes = [
        'text-black dark:text-white leading-relaxed text-base',
        '[&>*]:mb-4',
        '[&_h1]:text-3xl [&_h1]:font-black [&_h1]:mt-8 [&_h1]:mb-4 [&_h1]:text-black dark:[&_h1]:text-white',
        '[&_h2]:text-2xl [&_h2]:font-bold [&_h2]:mt-8 [&_h2]:mb-3 [&_h2]:text-black dark:[&_h2]:text-white [&_h2]:border-b [&_h2]:border-gray-200 [&_h2]:dark:border-gray-800 [&_h2]:pb-2',
        '[&_h3]:text-xl [&_h3]:font-bold [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-black dark:[&_h3]:text-white',
        '[&_h4]:text-lg [&_h4]:font-bold [&_h4]:mt-4 [&_h4]:mb-2',
        '[&_p]:leading-relaxed [&_p]:mb-4',
        '[&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-4 [&_ul]:space-y-2',
        '[&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:mb-4 [&_ol]:space-y-2',
        '[&_li]:leading-relaxed [&_li]:pl-1',
        '[&_strong]:font-bold [&_strong]:text-black dark:[&_strong]:text-white',
        '[&_em]:italic',
        '[&_a]:text-blue-600 [&_a]:underline [&_a]:hover:text-blue-800 dark:[&_a]:text-blue-400',
        '[&_code]:bg-gray-100 dark:[&_code]:bg-gray-800 [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-sm [&_code]:font-mono [&_code]:text-red-600 dark:[&_code]:text-red-400',
        '[&_pre]:bg-gray-900 [&_pre]:text-gray-100 [&_pre]:p-4 [&_pre]:rounded-lg [&_pre]:overflow-x-auto [&_pre]:my-6 [&_pre]:text-sm',
        '[&_pre_code]:bg-transparent [&_pre_code]:text-gray-100 [&_pre_code]:p-0',
        '[&_blockquote]:border-l-4 [&_blockquote]:border-black dark:[&_blockquote]:border-white [&_blockquote]:pl-4 [&_blockquote]:italic [&_blockquote]:my-6 [&_blockquote]:text-gray-600 dark:[&_blockquote]:text-gray-400',
        '[&_table]:w-full [&_table]:my-6 [&_table]:border-collapse',
        '[&_th]:border [&_th]:border-gray-300 dark:[&_th]:border-gray-700 [&_th]:bg-gray-50 dark:[&_th]:bg-gray-900 [&_th]:p-2 [&_th]:text-left [&_th]:font-bold',
        '[&_td]:border [&_td]:border-gray-200 dark:[&_td]:border-gray-800 [&_td]:p-2',
        '[&_hr]:my-8 [&_hr]:border-gray-200 dark:[&_hr]:border-gray-800',
        '[&_img]:rounded-lg [&_img]:my-6 [&_img]:max-w-full',
    ].join(' ');

    return <div className={classes} dangerouslySetInnerHTML={{ __html: text }} />;
};

export default StyledText;